// extracted by mini-css-extract-plugin
export default {"main":"main__55ae7221","motion_video":"motion_video__55ae7221","content":"content__55ae7221"};